import { render, staticRenderFns } from "./coupon-manage.vue?vue&type=template&id=e5bd9d06&scoped=true&"
import script from "./coupon-manage.vue?vue&type=script&lang=js&"
export * from "./coupon-manage.vue?vue&type=script&lang=js&"
import style0 from "./coupon-manage.vue?vue&type=style&index=0&id=e5bd9d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bd9d06",
  null
  
)

export default component.exports